import { useCallback, useMemo, useState } from 'react';
const ALL_STEPS = [
    'intro',
    'businessDetailsA',
    'businessDetailsB',
    'intent',
    'inviteTeam',
    'brand',
    'colors',
    'integrations',
    'waiting',
    'closing'
];
const DATA_COLLECTION_STEPS = new Set([
    'businessDetailsA',
    'businessDetailsB',
    'intent',
    'inviteTeam',
    'brand',
    'colors',
    'integrations'
]);
const SKIPPABLE_STEPS = new Set([
    'brand',
    'colors',
    'integrations'
]);
export const useOnboardingFlow = (options)=>{
    const [stepIndex, setStepIndex] = useState(0);
    const activeSteps = useMemo(()=>{
        if (options === null || options === void 0 ? void 0 : options.skipInviteTeam) {
            return ALL_STEPS.filter((step)=>step !== 'inviteTeam');
        }
        return ALL_STEPS;
    }, [
        options === null || options === void 0 ? void 0 : options.skipInviteTeam
    ]);
    const clampedIndex = Math.min(stepIndex, activeSteps.length - 1);
    const currentStep = activeSteps[clampedIndex];
    const activeDataCollectionSteps = useMemo(()=>activeSteps.filter((step)=>DATA_COLLECTION_STEPS.has(step)), [
        activeSteps
    ]);
    const dataCollectionIndex = activeDataCollectionSteps.indexOf(currentStep);
    const isDataCollectionStep = dataCollectionIndex >= 0;
    const isSkippableStep = SKIPPABLE_STEPS.has(currentStep);
    const progress = isDataCollectionStep ? (dataCollectionIndex + 1) / activeDataCollectionSteps.length * 100 : 0;
    const goNext = useCallback(()=>{
        setStepIndex((prev)=>Math.min(prev + 1, activeSteps.length - 1));
    }, [
        activeSteps.length
    ]);
    const goBack = useCallback(()=>{
        setStepIndex((prev)=>Math.max(prev - 1, 0));
    }, []);
    return {
        currentStep,
        progress,
        isDataCollectionStep,
        isSkippableStep,
        goNext,
        goBack
    };
};
